import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import NavbarSearch from '../NavbarSearch';
import useIsMobile from 'hooks/useIsMobile';
import NavbarLogo from '../NavbarLogo';
import { isCordova } from 'utils/platform';
import LoggedInLinks from './LoggedInLinks';
import DefaultNavbarLinks from './DefaultNavbarLinks';
import SubBars from 'modules/common/SubBars';
import { useUser } from '~/authentication/store';

const CSS = require('./TopNavbar.less');

interface TopNavbarProps {
  showSearch: boolean;
  transparent?: boolean;
  subNavbar?: string;
  nonFixedNavbar?: boolean;
  renderNavbarLinks?: (transparant: boolean) => React.ReactElement;
}

function TopNavbar({ showSearch, transparent, subNavbar, nonFixedNavbar, renderNavbarLinks }: TopNavbarProps) {
  const { isHost, isLoggedIn } = useUser();
  const isMobile = useIsMobile();
  const [openList, setOpenList] = useState(false);

  const toggleList = () => {
    document.body.classList.toggle(CSS.fixedMobileMenu, !openList);
    setOpenList(!openList);
  };

  const closeList = () => {
    document.body.classList.remove(CSS.fixedMobileMenu);
    setOpenList(false);
  };

  useEffect(() => document.body.classList.remove(CSS.fixedMobileMenu), []);

  return (
    <nav className={classnames(CSS.Navbar, { [CSS.NavbarNonFixed]: nonFixedNavbar })}>
      <div className={classnames(CSS.TopContainer, { [CSS.TopContainerTransparent]: !openList && transparent })}>
        <div className={classnames(CSS.mainNavbarContainer, { [CSS.mainNavbarContainerTransparent]: transparent })}>
          <>
            <NavbarLogo
              transparent={!openList && transparent}
              isMobile={isMobile}
              toggleList={toggleList}
              closeList={closeList}
              openList={openList}
              isHost={isHost}
            />
            <div className={CSS.mainNavbar}>
              {showSearch && <NavbarSearch isHost={isHost} isMobile={isMobile} />}
              {
                renderNavbarLinks ?
                  renderNavbarLinks(transparent) :
                  ((!isMobile || isHost) && !isCordova() &&
                    <div className={CSS.navbarRightContent}>
                      {isLoggedIn ?
                        <LoggedInLinks transparent={transparent} isHost={isHost} isMobile={isMobile} /> :
                        <DefaultNavbarLinks transparent={transparent} isMobile={isMobile} />
                      }
                    </div>
                  )
                  || isMobile && !showSearch &&
                  <div className={CSS.navbarRightContent}>
                    <DefaultNavbarLinks transparent={transparent} isMobile={isMobile} />
                  </div>
              }
            </div>
          </>
        </div>
      </div>
      {subNavbar && <SubBars type={subNavbar} transparent={transparent} />}
    </nav>
  );
}

export default TopNavbar;
